import api from "../pages/api/axios";

export const postLogin = async (data) => {
  const res = await api.post("/login", data);
  const r = res.data;

  return {
    // Keep the complete session response. Dropping refreshToken here leaves
    // every normal login unable to renew when its access token expires.
    ...r,
    status: r.status || 200,
    jwtInformation: {
      ...r.jwtInformation,
      uid: r.uid || r?.jwtInformation?.uid || r?.jwtInformation?.id,
      accessToken: r.accessToken,
      userData: r.userData || r.jwtInformation,
    },
  };
};


export const postLogout = () => {
  return api.post("/logout").then((res) => res.data);
};

export const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};
